"use client";
import axios from "axios";
import router from "@/router";

export function useAuth() {
  const BASE_URL = process.env.VUE_APP_BASE_URL || "http://localhost:5000";

  const login = async (credentials) => {
    const response = await axios.post(
      `${BASE_URL}/api/auth/login`,
      credentials
    );

    if (response.status === 200) {
      localStorage.setItem("token", response.data.token);
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${response.data.token}`;

      if (response.data.user) {
        localStorage.setItem("user", JSON.stringify(response.data.user));
      }

      return response.data;
    }
  };

  const redirectToDashboard = () => {
    router.push("/");
  };

  return {
    login,

    redirectToDashboard,
  };
}
